module.exports = __webpack_public_path__ + "static/media/orga5.cb9ae813.svg";